/**
 * Persisted Assets board UI: value mode (base vs market) + breakdown grouping.
 * Shared so Home overview card can match the board without duplicating localStorage keys.
 */

export const STORAGE_KEY_ASSETS_BOARD = 'qapp_finance_assets_board';

export const DEFAULT_ASSETS_BOARD = {
  valueMode: 'base',
  groupBy: 'location',
};

/** @returns {{ valueMode: 'base' | 'market', groupBy: 'location' | 'category' | 'subcategory' }} */
export const readAssetsBoardState = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_ASSETS_BOARD);
    if (!raw) return { ...DEFAULT_ASSETS_BOARD };
    const data = JSON.parse(raw);
    const valueMode = data.valueMode === 'market' ? 'market' : 'base';
    const groupBy = ['location', 'category', 'subcategory'].includes(data.groupBy) ? data.groupBy : 'location';
    return { valueMode, groupBy };
  } catch (_) {
    /* ignore */
  }
  return { ...DEFAULT_ASSETS_BOARD };
};

export const persistAssetsBoardState = (state) => {
  try {
    localStorage.setItem(
      STORAGE_KEY_ASSETS_BOARD,
      JSON.stringify({ valueMode: state.valueMode, groupBy: state.groupBy })
    );
  } catch (_) {
    /* ignore */
  }
};
